import differenceInHours from "date-fns/differenceInHours";
import differenceInMinutes from "date-fns/differenceInMinutes";
import differenceInSeconds from "date-fns/differenceInSeconds";

export const countdownString = (
  deadlineDate: Date,
  currentDate: Date
): string => {
  return `${differenceInHours(deadlineDate, currentDate)}:${toTwoDigits(
    differenceInMinutes(deadlineDate, currentDate) % 60
  )}:${toTwoDigits(differenceInSeconds(deadlineDate, currentDate) % 60)}`;
};

export const toTwoDigits = (value: number) =>
  String(value).slice(-2).padStart(2, "0");
